import React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import type { NormalizedDecisionMaker } from '../../types';

import { useDecisionMakerResponse } from './hooks/useDecisionMakerResponse';

export const DecisionMakerResponse: React.FC<{ response: NormalizedDecisionMaker['response'] }> = ({ response }) => {
	const {
		data: { responseText, readMoreLink, isTruncated, responseRef },
		actions: { trackReadFullDMResponseClick },
	} = useDecisionMakerResponse(response);

	return (
		<>
			<Text
				ref={responseRef}
				variant="body"
				className="mb-1 line-clamp-2 overflow-hidden font-serif wrap-anywhere text-ellipsis italic"
			>
				&ldquo;{responseText}&rdquo;
			</Text>

			{isTruncated && (
				<Link
					href={readMoreLink}
					size="small"
					className="block"
					data-qa="read-dm-response"
					variant="secondary"
					onClick={trackReadFullDMResponseClick}
				>
					<Translate value="corgi.petition_gamma.decision_makers_v2.read_full_response" />
				</Link>
			)}
		</>
	);
};
